<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="documentTemplates"
      :items="documentTemplates"
      :fields="documentTemplatesFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
      <editModal :editItem="selectedDocumentTemplates"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      documentTemplatesFields: [
        {key: 'template_id', label: this.$i18n.t('Template ID'), sortable: true},
        {key: 'typeEl', label: this.$i18n.t('Type'), sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'path', label: this.$i18n.t('Path'), sortable: true},
        {key: 'created', label: this.$i18n.t('Created'), sortable: true, formatter: (val, key, item) => { return val === 0 ? this.$i18n.t('Not installed') : this.$root.showDataWithTZDelta(val) }},
        {key: 'modified', label: this.$i18n.t('Modified'), sortable: true, formatter: (val, key, item) => { return val === 0 ? this.$i18n.t('Not installed') : this.$root.showDataWithTZDelta(val) }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      options: {
        isShowAddButton: true
      },
      selectedDocumentTemplates: null,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedDocumentTemplates = {
        template_id: 0,
        type: 1,
        name: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditDocumentTemplates', '#btnShow')
    },
    editItem (item) {
      this.selectedDocumentTemplates = item
      this.$root.$emit('bv::show::modal', 'modalEditDocumentTemplates', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Document templates"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_DOCUMENT_TEMPLATES', item.template_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_DOCUMENT_TEMPLATES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    documentTemplates () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/DOCUMENT_TEMPLATES']))
      for (let el of copy) {
        switch (el.type) {
          case 1:
            el.typeEl = this.$i18n.t('Bill') + ' (' + el.type + ')'
            break
          case 2:
            el.typeEl = this.$i18n.t('TAX invoice') + ' (' + el.type + ')'
            break
          case 3:
            el.typeEl = this.$i18n.t('User info sheet') + ' (' + el.type + ')'
            break
          case 4:
            el.typeEl = this.$i18n.t('Certificate of completion') + ' (' + el.type + ')'
            break
          case 5:
            el.typeEl = this.$i18n.t('Receipt') + ' (' + el.type + ')'
            break
          case 6:
            el.typeEl = this.$i18n.t('Contract') + ' (' + el.type + ')'
            break
          case 7:
            el.typeEl = this.$i18n.t('Bill details') + ' (' + el.type + ')'
            break
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_DOCUMENT_TEMPLATES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/documents/documentTemplates/main.vue